fragment CtCtActivity on ConstantContactContactTrackingActivity {
    id
    createdTime
    trackingActivityType
    campaignName
    subject
}
